import { Checkbox } from '@material-ui/core';
import { CheckBoxOutlineBlank, CheckBoxOutlined } from '@material-ui/icons';
import * as React from 'react';

export interface PrimOutCheckboxProps {
  id?: string;
  value: boolean;
  updateValue?: (value: boolean) => void;
  disabled?: boolean;
}
const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBoxOutlined fontSize="small" />;

const PrimOutCheckbox: React.FC<PrimOutCheckboxProps> = ({ value, updateValue, disabled }) => {
  return (
    <Checkbox
      icon={icon}
      checkedIcon={checkedIcon}
      checked={value}
      onChange={(event) => {
        const value = !!event?.target?.checked;
        updateValue ? updateValue(value) : null;
      }}
      size="small"
      disabled={disabled}
      color={'primary'}
      disableRipple
    />
  );
};

export default PrimOutCheckbox;
